exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-1ba96078]:nth-child(2n){background-color:#f4f5f7}h1[data-v-1ba96078]{min-width:50%}", ""]);

// exports
